import {
  ReportInformationFirstStep,
  ReportInformationFirstStepToSend,
} from "models/ReportInformationFirstStep";

export const transformReportModelToDetailsType = (
  reportDetails: ReportInformationFirstStep
): ReportInformationFirstStepToSend => {
  const convertedReportDetails: ReportInformationFirstStepToSend = {
    reportId: reportDetails.reportId,
    licensePlateTypeCode:
      reportDetails.vehicleDetails.licensePlateTypeCode ?? 1,
    licenseNumber: reportDetails.vehicleDetails.licenseNumber,
    modelType:
      reportDetails.vehicleDetails.modelType !== "null"
        ? reportDetails.vehicleDetails.modelType
        : null,
    carColor:
      reportDetails.vehicleDetails.carColor !== "null"
        ? reportDetails.vehicleDetails.carColor
        : null,
    manufacturerName:
      reportDetails.vehicleDetails.manufacturerName !== "null"
        ? reportDetails.vehicleDetails.manufacturerName
        : null,
    carModel:
      reportDetails.vehicleDetails.carModel !== "null"
        ? reportDetails.vehicleDetails.carModel
        : null,
    numOfVehicleInvolve: reportDetails.numOfVehicleInvolve,
    tags: reportDetails.tags,
    decisionTypeID: reportDetails.decisionTypeID,
    detailsAndAdditionalComments: reportDetails.detailsAndAdditionalComments,
    offenceTypeID: reportDetails.offenseTypeID,
    commentToSeniorController: reportDetails.commentToSeniorController,
    commentToPolice: reportDetails.commentToPolice,
    roadProblemDescription:
      reportDetails.reportIndication.roadProblemDescription,
    recommendForInformationalMaterial:
      reportDetails.reportIndication.recommendForInformationalMaterial,
    reportForImmediateTreatment:
      reportDetails.reportIndication.reportForImmediateTreatment,
    licenseNumberUnclear: reportDetails.reportIndication.licenseNumberUnclear,
    dataDoesNotMatch: reportDetails.reportIndication.dataDoesNotMatch,
    missingDetails: reportDetails.reportIndication.missingDetails,
    roadMarkUnclear: reportDetails.reportIndication.roadMarkUnclear,
    roadProblemPicture:
      reportDetails.reportRecordDto?.roadProblemPicture || null,
    extraPicture: reportDetails.reportRecordDto?.extraPicture || null,
    extraPictureTitle: reportDetails.reportRecordDto?.extraPictureTitle || null,
    offencePicture: reportDetails.reportRecordDto?.offencePicture,
    licenseNumberPicture:
      reportDetails.reportRecordDto?.licenseNumberPicture || null,
    reportVideo: reportDetails.reportRecordDto.reportVideo,
    rejectionReasonID: reportDetails.rejectionReasonID,
    whyOffenseSeriousCode: reportDetails.whyOffenseSeriousCode,
    driverOffenceTypeCode: reportDetails.driverOffenceTypeCode,
    problemReportTypeCode: reportDetails.problemReportTypeCode,
  };

  return convertedReportDetails;
};
